module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Liveshow":{"widgets.tipme.widget":[{"value":"Content_Tipme","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.SitePage_Liveshow","_fox_":1}],"widgets.tipme.embed.container":[{"value":"#tipme-form","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.SitePage_Liveshow","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/sitepage/liveshow/tipme.js
// module id = 712
// module chunks = 4